import React, { useRef } from 'react';
import { format, isToday, isValid, parseISO } from 'date-fns';
import useI18n from '@/hooks/useI18n';

interface LastUpdatedBadgeProps {
  lastRefreshedAt?: string | null;
  className?: string;
  /** Merged over the default pill styling, for pages with their own design. */
  style?: React.CSSProperties;
}

const LastUpdatedBadge = ({
  lastRefreshedAt,
  className = '',
  style,
}: LastUpdatedBadgeProps) => {
  const { t } = useI18n();
  const lastKnownRef = useRef<string | null | undefined>(lastRefreshedAt);

  if (lastRefreshedAt) {
    lastKnownRef.current = lastRefreshedAt;
  }

  const value = lastKnownRef.current;
  if (!value) return null;

  const parsed = parseISO(value);
  if (!isValid(parsed)) return null;

  const time = format(parsed, 'h:mm a');
  const label = `*${
    isToday(parsed)
      ? t('common.lastUpdatedToday', { time })
      : t('common.lastUpdatedDate', { date: format(parsed, 'MMM d'), time })
  }`;

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-[72px] ${className}`}
      style={{
        width: 366,
        height: 36,
        padding: '4px 12px',
        gap: 16,
        backgroundColor: '#E2E6F0',
        color: '#172B4D',
        fontFamily: 'Manrope, sans-serif',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '22px',
        letterSpacing: 0,
        ...style,
      }}
      title={String(label)}
    >
      {String(label)}
    </span>
  );
};

export default LastUpdatedBadge;
